import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseCurriculumUnits } from '@/api/responses/manage/curriculumUnits'

export namespace CurriculumUnitsApi {
  /**
   * 単元一覧取得API
   *
   * @param studentId 生徒ID
   * @param studyCategoryId 教材ID
   * @returns 単元一覧
   */
  export async function getCurriculumUnits(
    studentId: number,
    studyCategoryId: number
  ): Promise<ApiResponseCurriculumUnits> {
    const params = {
      studentId: studentId,
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get('/manage/curriculumUnits', params)
  }
}
